module.exports = __webpack_public_path__ + "img/logo.99a5aeef.png";